"use strict";
/* eslint-disable react/prop-types */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CommentHeader = void 0;
var dateformat_1 = __importDefault(require("dateformat"));
var react_1 = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../../Icon/Icon"));
var wagtailConfig_1 = require("../../../../config/wagtailConfig");
// Details/Summary components that just become <details>/<summary> tags
// except for IE11 where they become <div> tags to allow us to style them
var Details = (function (_a) {
    var children = _a.children, open = _a.open, extraProps = __rest(_a, ["children", "open"]);
    if (wagtailConfig_1.IS_IE11) {
        return (react_1["default"].createElement("div", __assign({ className: 'details-fallback' + (open ? ' details-fallback--open' : '') }, extraProps), children));
    }
    return (react_1["default"].createElement("details", __assign({ open: open }, extraProps), children));
});
var Summary = function (_a) {
    var children = _a.children, extraProps = __rest(_a, ["children"]);
    if (wagtailConfig_1.IS_IE11) {
        return (react_1["default"].createElement("button", __assign({ className: "details-fallback__summary" }, extraProps), children));
    }
    return (react_1["default"].createElement("summary", __assign({}, extraProps), children));
};
var CommentHeader = function (_a) {
    var commentReply = _a.commentReply, store = _a.store, strings = _a.strings, onResolve = _a.onResolve, onEdit = _a.onEdit, onDelete = _a.onDelete, descriptionId = _a.descriptionId, focused = _a.focused;
    var author = commentReply.author, date = commentReply.date;
    var onClickResolve = function (e) {
        e.preventDefault();
        if (onResolve) {
            onResolve(commentReply, store);
        }
    };
    var onClickEdit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            e.preventDefault();
            if (onEdit) {
                onEdit(commentReply, store);
            }
            return [2 /*return*/];
        });
    }); };
    var onClickDelete = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            e.preventDefault();
            if (onDelete) {
                onDelete(commentReply, store);
            }
            return [2 /*return*/];
        });
    }); };
    var _b = __read(react_1.useState(false), 2), menuOpen = _b[0], setMenuOpen = _b[1];
    react_1.useEffect(function () {
        if (menuOpen && !focused) {
            setMenuOpen(false);
        }
    }, [focused]);
    var menuRef = react_1.useRef(null);
    var menuContainerRef = react_1.useRef(null);
    var toggleMenu = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setMenuOpen(!menuOpen);
    };
    react_1.useEffect(function () {
        if (menuOpen) {
            setTimeout(function () { var _a; return (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 1);
        }
    }, [menuOpen]);
    var handleClickOutside = function (e) {
        if (menuContainerRef.current && e.target instanceof Node && !menuContainerRef.current.contains(e.target)) {
            setMenuOpen(false);
        }
    };
    react_1.useEffect(function () {
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    return (react_1["default"].createElement("div", { className: "comment-header" },
        react_1["default"].createElement("div", { className: "comment-header__actions" }, (onEdit || onDelete || onResolve) &&
            react_1["default"].createElement("div", { className: "comment-header__action comment-header__action--more", ref: menuContainerRef },
                react_1["default"].createElement(Details, { open: menuOpen, onClick: toggleMenu },
                    react_1["default"].createElement(Summary, { "aria-label": strings.MORE_ACTIONS, "aria-haspopup": "menu", role: "button", onClick: toggleMenu, "aria-expanded": menuOpen },
                        react_1["default"].createElement(Icon_1["default"], { name: "ellipsis-v" })),
                    react_1["default"].createElement("div", { className: "comment-header__more-actions", role: "menu", ref: menuRef },
                        onEdit && react_1["default"].createElement("button", { type: "button", role: "menuitem", onClick: onClickEdit }, strings.EDIT),
                        onDelete && react_1["default"].createElement("button", { type: "button", role: "menuitem", onClick: onClickDelete }, strings.DELETE),
                        onResolve && react_1["default"].createElement("button", { type: "button", role: "menuitem", onClick: onClickResolve }, strings.RESOLVE))))),
        author && author.avatarUrl &&
            react_1["default"].createElement("img", { className: "comment-header__avatar", src: author.avatarUrl, role: "presentation" }),
        react_1["default"].createElement("span", { id: descriptionId },
            react_1["default"].createElement("p", { className: "comment-header__author" }, author ? author.name : ''),
            react_1["default"].createElement("p", { className: "comment-header__date" }, dateformat_1["default"](date, 'd mmm yyyy HH:MM')))));
};
exports.CommentHeader = CommentHeader;
